module.exports = __webpack_public_path__ + "img/copyright-grey-outline.d492345a.svg";